import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=bf17510e&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=bf17510e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf17510e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf17510e')) {
      api.createRecord('bf17510e', component.options)
    } else {
      api.reload('bf17510e', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=bf17510e&scoped=true&", function () {
      api.rerender('bf17510e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4ehnmpcYy45av/JS/comp/GuestBox.vue"
export default component.exports